import { get, post } from './axios.js'

/**
 * 영업기회 조회 - /sales/salesOptyList
 * @param {object} params
 * @property {string} params.end_user_cmp_nm
 * @property {string} params.sales_cmp_nm
 * @property {string} params.tax_dt_s
 * @property {string} params.tax_dt_e
 * @property {string} params.stage_cd
 * @returns
 */
export async function salesOptyList(params = {}) {
  try {
    const result = await post('/sales/salesOptyList', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}
    
/**
 * 영업기회 등록/수정 - /sales/salesOptyEdit
 * @param {object} params
 * @property {string} params.opty_seq
 * @property {string} params.sales_id - 영업기회id
 * @property {string} params.sales_cmp_info_seq - 매출처(회사관리번호로 관리)
 * @property {string} params.sales_cmp_nm - 매출처이름
 * @property {string} params.end_user_cmp_info_seq - endUser(회사관리번호로 관리)
 * @property {string} params.end_user_cmp_nm - endUser이름
 * @property {string} params.manager1 - 담당자1
 * @property {string} params.manager2 - 담당자2
 * @property {string} params.sales_nm - 영업기회명
 * @property {string} params.sales_ceo - 영업대표
 * @property {string} params.employee_id
 * @property {string} params.maker_cmp_info_seq - 제조사(회사관리번호로 관리)
 * @property {string} params.maker_cmp_nm - 제조사이름
 * @property {string} params.stage_cd - stage(공통코드)
 * @property {string} params.bnr_cd - Bridge&Risk(공통코드)
 * @property {string} params.tax_dt - 매출세금계산서 발행일(일자)
 * @property {string} params.collect_dt - 수금일(일자) 
 * @property {string} params.tax_yn - 발행여부
 * @property {string} params.collect_yn - 수금여부
 * @property {string} params.reg_dt - 최초 등록일
 * @property {string} params.won_dt - 우선협상자 선정일(일자)
 * @property {string} params.po_dt- po발행일
 * @property {string} params.custom_po - 고객PO
 * @property {string} params.prd_info - 상품(납품)정보
 * @property {string} params.dlv_dt - 납품완료일
 * @property {string} params.psp_yn - PSP지정여부
 * @property {string} params.isp_dt - 검수완료일(일자)
 * @property {string} params.w_sales_id - Warranty 영업기회 매핑 id
 * @property {string} params.w_end_dt - Warranty End Date(일자)
 * @property {string} params.w_end_ck - Warranty End Date 체크(1:체크)
 * @property {string} params.w_alarm_yn
 * @property {string} params.ngt_date
 * @property {string} params.bkmark_yn - 즐겨찾기
 * @property {string} params.memo - 메모
 * @property {string} params.outcome_sum - 총매출금액
 * @property {string} params.income_sum - 총매입금액
 * @property {string} params.gm_amt - GM AMT(매출-매입)
 * @property {string} params.gm_amt_per - GM Amt/매출
 * @property {string} params.tmp_yn
 * @property {string} params.cap_seq
 * @property {string} params.tb_id
 * @property {object} params.attachFileVO
 * @property {string} params.attachFileVO.file_div_id
 * @property {string} params.attachFileVO.file_seq - 추가 된 파일 seq 전송
 * @property {string} params.attachFileVO.del_file_seq - 삭제해야 할 파일 seq 전송
 * @returns
 */
export async function salesOptyEdit(params = {}) {
  try {
    const result = await post('/sales/salesOptyEdit', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 영업기회 상세 조회 - /sales/salesOptySelect
 * @param {object} params
 * @property {string} params.opty_seq
 * @property {string} params.sales_id
 * @returns
 */
export async function salesOptySelect(params = {}) {
  try {
    const result = await post('/sales/salesOptySelect', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 매입매출 조회 - /sales/salesOptyInoutList
 * @param {object} params
 * @property {string} params.opty_seq
 * @property {string} params.sales_id
 * @property {string} params.buy_cmp_info_nm
 * @returns
 */
export async function salesOptyInoutList(params = {}) {
  try {
    const result = await post('/sales/salesOptyInoutList', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 매입매출 등록/수정 - /sales/salesOptyInoutListEdit
 * @param {object} params
 * @property {string} params.sales_id
 * @property {string} params.opty_seq
 * @property {string} params.tax_sale_dt
 * @property {string} params.pay_dt
 * @returns
 */
export async function salesOptyInoutListEdit(params = {}) {
  try {
    const result = await post('/sales/salesOptyInoutListEdit', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 매입매출 삭제 - /sales/salesOptyInoutListDel
 * @param {object} params
 * @property {string} params.sales_id
 * @property {string} params.opty_seq
 * @property {string} params.tax_sale_dt
 * @property {string} params.pay_dt
 * @returns
 */
export async function salesOptyInoutListDel(params = {}) {
  try {
    const result = await post('/sales/salesOptyInoutListDel', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}


/**
 * 영업기회+매입매출 조회 - /sales/salesOptyExcelList
 * @param {object} params
 * @returns
 */
export async function salesOptyExcelList(params = {}) {
  try {
    const result = await post('/sales/salesOptyExcelList', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 영업기회 이력 조회 - /sales/salesOptyHistList
 * @param {object} params
 * @property {string} params.opty_seq
 * @property {string} params.sales_id
 * @returns
 */
export async function salesOptyHistList(params = {}) {
  try {
    const result = await post('/sales/salesOptyHistList', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 매입매출 이력 조회 - /sales/salesOptyInoutHistList
 * @param {object} params
 * @property {string} params.opty_seq
 * @property {string} params.sales_id
 * @property {string} params.buy_cmp_info_nm
 * @returns
 */
export async function salesOptyInoutHistList(params = {}) {
  try {
    const result = await post('/sales/salesOptyInoutHistList', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 영업기회 엑셀 파일 업로드 - /sales/optyExcelUpload
 * @param {object} params
 * @returns
 */
export async function optyExcelUpload(params = {}) {
  try {
    const result = await post('/sales/optyExcelUpload', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}